import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from 'src/pages/layouts/DashboardLayout';
import AuthenticationLoginPage from './pages/authentication/AuthenticationLoginPage';

const Home = lazy(() => import('src/pages/home/index'));
const MapeamentoProdutos = lazy(() => import('src/pages/estoque/produtos/mapeamento/index'));
const AlocacaoProdutos = lazy(() => import('src/pages/estoque/produtos/alocacao/index'));
const SeparacaoProdutos = lazy(() => import('src/pages/expedicao/separacao/index'));
const SeparacaoCaixa = lazy(() => import('src/pages/expedicao/separacao/caixa'));
const SeparacaoOperacao = lazy(() => import('src/pages/expedicao/separacao/separacao'));
const Conferencia = lazy(() => import('src/pages/expedicao/conferencia'));
const ListagemProdutos = lazy(() => import('src/pages/estoque/produtos/listagem/index'));
const VisualizarProduto = lazy(() => import('src/pages/estoque/produtos/visualizacao/index'));
const TransfenciaProduto = lazy(() => import('src/pages/estoque/produtos/transferencia/index'));
const Transferindo = lazy(() => import('src/pages/estoque/produtos/transferir/realizar'));
const CaixaSeparacao = lazy(() => import('src/pages/cadastros/caixa_de_separacao/index'));
const Embalagens = lazy(() => import('src/pages/cadastros/embalagens/index'));
const EditEmbalagens = lazy(() => import('src/pages/cadastros/embalagens/edit'));
const MovmentacaoEstoque = lazy(() => import('src/pages/estoque/produtos/movimentacao'));
const Usuarios = lazy(() => import('src/pages/sistema/usuarios'));
const EditUsuarios = lazy(() => import('src/pages/sistema/usuarios/edit'));
const VisualizarLogs = lazy(() => import('src/pages/sistema/visualizar_logs'));
const RelacaoDeVolumes = lazy(() => import('src/pages/expedicao/relacao_volumes'));
const ExpedicoesRealizadas = lazy(() => import('src/pages/expedicao/expedicoes_realizadas'));
const PesquisaRapida = lazy(() => import('src/pages/estoque/produtos/pesquisa_rapida'));
const PrioridadeSeparacao = lazy(() => import('src/pages/sistema/prioridade_separacao'));
const SolicitaTransferencia = lazy(() => import('src/pages/estoque/produtos/transferencia/solicita'));
const InventarioLivre = lazy(() => import('src/pages/estoque/produtos/inventario_livre'));
const InventariarList = lazy(() => import('src/pages/estoque/produtos/inventariar'));
const InventarioLista = lazy(() => import('src/pages/estoque/produtos/inventario'));
const InventarioEdit = lazy(() => import('src/pages/estoque/produtos/inventario/edit'));
const Inventariando = lazy(() => import('src/pages/estoque/produtos/inventariar/realizar'));
const DivergenciaEstoque = lazy(() => import('src/pages/relatorios/divergencia_estoque/index'));
const EnderecoZerado = lazy(() => import('src/pages/relatorios/enderecos_zerado/index'));
const Enderecos = lazy(() => import('src/pages/cadastros/enderecos/index'));
const ProdutosCurvaA = lazy(() => import('./pages/relatorios/curva_a'));
const Transferir = lazy(() => import('src/pages/estoque/produtos/transferir'));
const Recebimentos = lazy(() => import('src/pages/estoque/produtos/recebimentos/receber'));
const EditRecebimentos = lazy(() => import('src/pages/estoque/produtos/recebimentos/receber/edit'));
const VisualizarRecebimentos = lazy(() => import('src/pages/estoque/produtos/recebimentos/visualizar_recebimento'));
const AgendaRecebimentos = lazy(() => import('src/pages/estoque/produtos/recebimentos/agenda_recebimento'));
const AprovaAgendamento = lazy(() => import('src/pages/estoque/produtos/recebimentos/aprovar_agendamentos/index'));
const RecebimentosCadastrarRecebimento = lazy(
  () => import('src/pages/estoque/produtos/recebimentos/cadastrar_recebimento')
);
const EditRecebimentosNfe = lazy(() => import('src/pages/estoque/produtos/recebimentos/cadastrar_recebimento/newedit'));
const NovoRecebimento = lazy(() => import('src/pages/estoque/produtos/recebimentos/cadastrar_recebimento/new'));
const Transportadora = lazy(
  () => import('src/pages/estoque/produtos/recebimentos/cadastrar_recebimento/transportadora')
);
const SolicitacoesInventarioLista = lazy(() => import('src/pages/estoque/produtos/solicitacoes_inventario'));
const AcoesDeUsuarios = lazy(() => import('src/pages/relatorios/acoes_de_usuarios/index'));
const DivergenciaRecebimento = lazy(() => import('src/pages/relatorios/divergencia_recebimento/index'));
const PedidosLista = lazy(() => import('src/pages/vendas/index'));
const CadastrarPedido = lazy(() => import('src/pages/vendas/order_create'));
const DetalharPedido = lazy(() => import('src/pages/vendas/order_detail'));
const PrevisaoMovimentacao = lazy(
  () => import('src/pages/estoque/produtos/ressuprimento/movimentacao_por_necessidade/index')
);
const ConfigurarAgenda = lazy(() => import('src/pages/estoque/produtos/recebimentos/configurar_agenda'));
const Armazens = lazy(() => import('src/pages/cadastros/armazens/index'));
const RecebimentosDashboard = lazy(() => import('src/pages/estoque/produtos/recebimentos/dashboard/index'));

const routes = [
  {
    path: 'login',
    element: (
      <Suspense>
        <AuthenticationLoginPage />
      </Suspense>
    ),
  },
  {
    path: 'app',
    element: (
      <DashboardLayout>
        <Suspense fallback={<div>Carregando...</div>}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to='home'
            replace
          />
        ),
      },
      {
        path: 'home',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
      },
      {
        path: 'cadastro',
        children: [
          {
            path: 'armazens',
            element: (
              <Suspense>
                <Armazens />
              </Suspense>
            ),
          },
          {
            path: 'armazens/:storage_id/enderecos',
            element: (
              <Suspense>
                <Enderecos />
              </Suspense>
            ),
          },
          {
            path: 'caixa_separacao',
            element: (
              <Suspense>
                <CaixaSeparacao />
              </Suspense>
            ),
          },
          {
            path: 'embalagens',
            element: (
              <Suspense>
                <Embalagens />
              </Suspense>
            ),
          },
          {
            path: 'embalagens/editar/:id',
            element: (
              <Suspense>
                <EditEmbalagens />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'vendas',
        children: [
          {
            path: 'pedidos',
            element: (
              <Suspense>
                <PedidosLista />
              </Suspense>
            ),
          },
          {
            path: 'pedidos/cadastro',
            element: (
              <Suspense>
                <CadastrarPedido />
              </Suspense>
            ),
          },
          {
            path: 'pedidos/detalhes',
            element: (
              <Suspense>
                <DetalharPedido />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'estoque',
        children: [
          {
            path: 'pesquisa/rapida',
            element: (
              <Suspense>
                <PesquisaRapida />
              </Suspense>
            ),
          },
          {
            path: 'mapeamento/produtos',
            element: (
              <Suspense>
                <MapeamentoProdutos />
              </Suspense>
            ),
          },
          {
            path: 'alocacao/produtos',
            element: (
              <Suspense>
                <AlocacaoProdutos />
              </Suspense>
            ),
          },
          {
            path: 'alocacao/produtos/:callback/:ean_produto',
            element: (
              <Suspense>
                <AlocacaoProdutos />
              </Suspense>
            ),
          },
          {
            path: 'listagem/produtos',
            element: (
              <Suspense>
                <ListagemProdutos />
              </Suspense>
            ),
          },
          {
            path: 'visualizar/produto/:id',
            element: (
              <Suspense>
                <VisualizarProduto />
              </Suspense>
            ),
          },
          {
            path: 'movimentacao/produtos',
            element: (
              <Suspense>
                <MovmentacaoEstoque />
              </Suspense>
            ),
          },
          {
            path: 'transferencia/produtos',
            element: (
              <Suspense>
                <TransfenciaProduto />
              </Suspense>
            ),
          },
          {
            path: 'transferencia/produtos/:id',
            element: (
              <Suspense>
                <SolicitaTransferencia />
              </Suspense>
            ),
          },
          {
            path: 'inventario/livre',
            element: (
              <Suspense>
                <InventarioLivre />
              </Suspense>
            ),
          },
          {
            path: 'inventariar/lista',
            element: (
              <Suspense>
                <InventariarList />
              </Suspense>
            ),
          },
          {
            path: 'inventariar/:inventory_id/endereco/:id',
            element: (
              <Suspense>
                <Inventariando />
              </Suspense>
            ),
          },
          {
            path: 'transferir',
            element: (
              <Suspense>
                <Transferir />
              </Suspense>
            ),
          },
          {
            path: 'transferir/:id',
            element: (
              <Suspense>
                <Transferindo />
              </Suspense>
            ),
          },
          {
            path: 'inventario/lista',
            element: (
              <Suspense>
                <InventarioLista />
              </Suspense>
            ),
          },
          {
            path: 'inventario/editar/:id',
            element: (
              <Suspense>
                <InventarioEdit />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/dashboard',
            element: (
              <Suspense>
                <RecebimentosDashboard />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/receber',
            element: (
              <Suspense>
                <Recebimentos />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/receber/editar/:id',
            element: (
              <Suspense>
                <EditRecebimentos />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/cadastrar_recebimento/new',
            element: (
              <Suspense>
                <NovoRecebimento />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/visualizar',
            element: (
              <Suspense>
                <VisualizarRecebimentos />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/agenda_recebimento',
            element: (
              <Suspense>
                <AgendaRecebimentos />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/configurar_agenda',
            element: (
              <Suspense>
                <ConfigurarAgenda />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/aprovar_agendamentos',
            element: (
              <Suspense>
                <AprovaAgendamento />
              </Suspense>
            ),
          },
          {
            path: 'recebimentos/cadastrar_recebimento',
            element: (
              <Suspense>
                <RecebimentosCadastrarRecebimento />
              </Suspense>
            ),
            handle: { isPublic: true },
          },
          {
            path: 'recebimentos/cadastrar_recebimento/editar/:id',
            element: (
              <Suspense>
                <EditRecebimentosNfe />
              </Suspense>
            ),
          },
          {
            path: 'inventario/solicitacoes',
            element: (
              <Suspense>
                <SolicitacoesInventarioLista />
              </Suspense>
            ),
          },
          {
            path: 'ressuprimento',
            children: [
              {
                path: 'movimentacao_por_necessidade',
                element: (
                  <Suspense>
                    <PrevisaoMovimentacao />
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: 'expedicao',
        children: [
          {
            path: 'separacao',
            element: (
              <Suspense>
                <SeparacaoProdutos />
              </Suspense>
            ),
          },
          {
            path: 'separacao_caixa/:id',
            element: (
              <Suspense>
                <SeparacaoCaixa />
              </Suspense>
            ),
          },
          {
            path: 'separacao_operacao/:id',
            element: (
              <Suspense>
                <SeparacaoOperacao />
              </Suspense>
            ),
          },
          {
            path: 'relacao_de_volumes',
            element: (
              <Suspense>
                <RelacaoDeVolumes />
              </Suspense>
            ),
          },
          {
            path: 'expedicoes_realizadas',
            element: (
              <Suspense>
                <ExpedicoesRealizadas />
              </Suspense>
            ),
          },
          {
            path: 'conferencia',
            element: (
              <Suspense>
                <Conferencia />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'relatorios',
        children: [
          {
            path: 'divergencia_estoque',
            element: (
              <Suspense>
                <DivergenciaEstoque />
              </Suspense>
            ),
          },
          {
            path: 'endereco_zerado',
            element: (
              <Suspense>
                <EnderecoZerado />
              </Suspense>
            ),
          },
          {
            path: 'curva_a',
            element: (
              <Suspense>
                <ProdutosCurvaA />
              </Suspense>
            ),
          },
          {
            path: 'acoes_de_usuarios',
            element: (
              <Suspense>
                <AcoesDeUsuarios />
              </Suspense>
            ),
          },
          {
            path: 'divergencia_recebimento',
            element: (
              <Suspense>
                <DivergenciaRecebimento />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'sistema',
        children: [
          {
            path: 'usuarios',
            element: (
              <Suspense>
                <Usuarios />
              </Suspense>
            ),
          },
          {
            path: 'usuarios/cadastro/:id',
            element: (
              <Suspense>
                <EditUsuarios />
              </Suspense>
            ),
          },
          {
            path: 'visualizar/logs',
            element: (
              <Suspense>
                <VisualizarLogs />
              </Suspense>
            ),
          },
          {
            path: 'prioridade-separacao',
            element: (
              <Suspense>
                <PrioridadeSeparacao />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'logout',
        element: (
          <Navigate
            to='/'
            replace
          />
        ),
      },
    ],
  },
  {
    path: '/transportadora',
    element: (
      <Suspense>
        <Transportadora />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <Navigate
        to='/login'
        replace
      />
    ),
  },
  {
    path: '*',
    element: (
      <Navigate
        to='/login'
        replace
      />
    ),
  },
];

export default routes;
